<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
      </div>
      <div class="wechat-login-btn" @click="newAuthLogin">
        <img src="@assets/images/wechat_login.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { toNewLoginAuth } from "@libs/wechat";

export default {
  name: "Login",
  data: function() {
    return {
      logoUrl: ""
    };
  },
  mounted: function() {
    this.getLogoImage();
  },
  computed: {
    hasSpread() {
      return (
        cookie.has("spread") ||
        (cookie.get("spread") != null &&
          typeof cookie.get("spread") == "number")
      );
    }
  },
  methods: {
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    newAuthLogin() {
      toNewLoginAuth();
    }
  }
};
</script>
<style scoped lang="scss">
.register {
  display: flex;
  justify-content: center;
  align-items: center;
  .shading {
    padding-top: 0;
    height: auto;
    text-align: center;
    .wechat-login-btn {
      margin-top: 1.36rem;
    }
  }
}
</style>
